<div class="business-unification-root" *transloco="let t">

    <div class="page-title-desktop">
      <app-header>{{t('business-unification')}}</app-header>
    </div>

    <div id="subheader-actions" class="subheader-actions">

      <div class="page-filters">

        <app-multiselect-filter [chips]="statusChips"
                                [filterArray]="filters.status"
                                [filterName]="'Status'"
                                (selectFilterClick)="updateStatusFilter($event)">
        </app-multiselect-filter>

        <div class="search">
          <app-input
            id="search-business-unification-input"
            [placeholder]="t('business-unification-search')"
            [type]="'search'"
            [control]="search"
            (searchClick)="getUnificationList()"
          >
          </app-input>
        </div>

      </div>


      <div class="page-actions">
        <app-primary-button [disabled]="loading"
                            (clickAction)="showNewBusinessUnificationModal()">
          {{t('new-business-unification')}}
        </app-primary-button>
      </div>

    </div>

    <div class="unification-header">
      <div class="unification-origins">
        {{ 'businesses-to-unify' | transloco}}
      </div>
      <div class="unification-destination">
        {{ 'destination-business' | transloco}}
      </div>
      <div class="unification-status">
        {{ 'status' | transloco}}
      </div>
      <div class="unification-actions">
        {{ 'actions' | transloco}}
      </div>

    </div>

    <div *ngFor="let item of unificationList" class="unification-list">
      <div class="unification-item-line" >
        <div class="unification-origins">
          <div class="unification-origins-list">
            <div *ngFor="let originBusiness of item.businessesOrigins; let i = index">
              <div *ngIf="i < 3" class="unification-origins-list-item">
                <div>
                  {{originBusiness.businessName}}
                </div>
                <div *ngIf="item.status !== 'IN_PROGRESS' && item.status !== 'UNIFIED'">
                  ({{originBusiness.totalPoints}} pts)
                </div>
              </div>
              
            </div>
            <div *ngIf="item.businessesOrigins.length > 3" class="unification-origins-list-item show-more" (click)="showUnificationDetails(item.id)">
              {{ 'show-more' | transloco}}
            </div>
          </div>
        </div>
        <div class="unification-destination unification-destination-value">
          <div class="unification-destination-name">
            <mat-icon>arrow_right_alt</mat-icon>
          </div>
          <div class="unification-destination-name">
            {{item.businessDestination.businessName}} ({{item.totalPoints}} pts)
          </div>
        </div>
        <div class="unification-status">
          <app-business-unification-status [status]="item.status">
          </app-business-unification-status>
        </div>
        <div class="unification-actions">
          <div class="unification-action" *ngIf="item.status === 'PENDING' && isGlobalAdmin()">
            <button class="action-button accept-button"
                    mat-icon-button
                    (click)="acceptUnification(item.id)"
                    [matTooltip]="t('accept')">
              <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
            </button>
          </div>
          <div class="unification-action" *ngIf="item.status === 'PENDING' && isGlobalAdmin()">
            <button class="action-button reject-button"
                    mat-icon-button
                    (click)="rejectUnification(item.id)"
                    [matTooltip]="t('reject')">
              <nb-icon icon="close-circle-outline"></nb-icon>
            </button>
          </div>
          <div class="unification-action" *ngIf="item.status !== 'IN_PROGRESS' && item.status !== 'UNIFIED'">
            <button class="action-button info-button"
                    mat-icon-button
                    (click)="showUnificationDetails(item.id)"
                    [matTooltip]="t('more-details')">
              <nb-icon icon="info-outline"></nb-icon>
            </button>
          </div>
          <div class="unification-action" *ngIf="item.status === 'UNIFIED'">
            <button class="action-button info-button"
                    mat-icon-button
                    (click)="downloadReportReportFile(item.id)"
                    [matTooltip]="t('download-reports')">
              <nb-icon icon="download"></nb-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

</div>
